import type { Room, RoomConnectOptions } from 'livekit-client';
import { ConnectionState } from 'livekit-client';

type TokenUpdatableEngine = {
  engine?: {
    client?: {
      handleTokenUpdate?: (token: string) => Promise<void>;
    };
  };
};

/**
 * Renova JWT sem desconectar quando o SDK suporta handleTokenUpdate;
 * fallback: room.connect (reconexão completa).
 */
export async function applyParticipantTokenRefresh(
  room: Room,
  serverUrl: string,
  participantToken: string,
  connectOptions: RoomConnectOptions,
): Promise<void> {
  const engine = (room as TokenUpdatableEngine).engine;
  const handleTokenUpdate = engine?.client?.handleTokenUpdate;

  if (
    room.state === ConnectionState.Connected &&
    typeof handleTokenUpdate === 'function'
  ) {
    await handleTokenUpdate(participantToken);
    return;
  }

  await room.connect(serverUrl, participantToken, connectOptions);
}
